import { Env } from '/@/Env';
import GoogleTagManagerHelper from '/@/integrations/googletagmanager/GoogleTagManagerHelper';
import { GoogleTagManager } from '/@/integrations/googletagmanager/googletagmanager.constants';

class GoogleTagManagerService {
  /**
   * @var {GoogleTagManagerHelper}
   */
  googleTagManagerHelper;

  static CONVERSION = 'conversion';

  static CONFIG = 'config';

  static EVENT = 'event';

  static JS = 'js';

  static GTM_START = 'gtm.start';

  static GTM_JS = 'gtm.js';

  constructor() {
    this.googleTagManagerHelper = GoogleTagManagerHelper;
  }

  init() {
    if (Env.isProduction()) {
      this.initGlobalSiteTag(GoogleTagManager.FREE_WILL_CONVERSION_ID);
      this.initTagManager(GoogleTagManager.HOTJAR_GTM_ID);
      this.initTagManager(GoogleTagManager.GA_TRACKER_ID);
    }
  }

  initTagManager(id) {
    this.googleTagManagerHelper.init(id, GoogleTagManager.GTM_LINK);
    this.gtag({
      [GoogleTagManagerService.GTM_START]: new Date().getTime(),
      event: GoogleTagManagerService.GTM_JS
    });
  }

  initGlobalSiteTag(id) {
    this.googleTagManagerHelper.init(id, GoogleTagManager.GTAG_LINK);
    this.gtag(GoogleTagManagerService.JS, new Date());
    this.gtag(GoogleTagManagerService.CONFIG, id);
  }

  gtag(...params) {
    if (Env.isProduction()) {
      this.googleTagManagerHelper.gtag(...params);
    }
  }

  pushToDataLayer(dataLayerItem) {
    if (!dataLayerItem) {
      return;
    }

    this.googleTagManagerHelper.pushToDataLayer(dataLayerItem);
  }

  sendConversion(conversionAction) {
    this.gtag(GoogleTagManagerService.EVENT, GoogleTagManagerService.CONVERSION, {
      send_to: conversionAction
    });
  }
}

export default new GoogleTagManagerService();
